module.exports = __webpack_public_path__ + "img/美妆-6.a5c1154d.png";